import { dataCheck } from '@/utils'
export const CUSTOMER_COLUMNS = [
  {
    prop: 'id',
    label: window.$t('product-manager::prop::table_no'),
    type: 'index',
    fixed: 'left',
    width: '80'
  },
  {
    prop: 'type',
    label: window.$t('product-manager::prop::table_type'),
    formatter: row => dataCheck({ 1: window.$t('product-manager::prop::custom_prop'), 2: window.$t('product-manager::prop::trigger_prop') }[row.type]),
    minWidth: '120'
  },
  {
    prop: 'name',
    label: window.$t('product-manager::prop::table_name'),
    formatter: row => dataCheck(row.name),
    minWidth: '150'
  },
  {
    prop: 'createTime',
    label: window.$t('product-manager::prop::table_creatTime'),
    formatter: row => dataCheck(row.createTime),
    minWidth: '150'
  },
  {
    prop: 'operate',
    label: window.$t('product-manager::prop::table_handle'),
    width: '180',
    fixed: 'right',
  }
]
export const data = [
  {
    number: 1,
    propName: '尺寸',
    createTime: '2021-04-09 9:00'
  }
]
